export default __webpack_public_path__ + "b38b6ac2be05953955e72c47b648afbe.png";